<div [class]="'col' + (!props.readonly && props.editFieldStyleClass ? ' ' + props.editFieldStyleClass : '')">
  @if (props.readonly) {
    <new-ui-wrapper-readonly
      [label]="props.label"
      [value]="
        formControl.value
          | newUiLabel: (props.options | formlySelectOptions: field | async) : 'value' : 'label' : null : null : false
      "
    />
  } @else {
    <div class="flex flex-wrap gap-4">
      @for (option of props.options | formlySelectOptions: field | async; track option.value) {
        <new-ui-radiobutton
          [formControl]="$any(formControl)"
          [label]="option.label"
          [value]="option.value"
          [name]="field.name || id"
          [required]="props.required && $first"
          [readonly]="props.readonly"
          [badgeDisabled]="props.badgeDisabled"
        />
      }
    </div>
  }

  @if (showError) {
    <p-message severity="error" variant="simple" size="small">
      <formly-validation-message [field]="field" />
    </p-message>
  }
</div>
